import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=374fe26c&scoped=true&"
import script from "./feature.vue?vue&type=script&lang=js&"
export * from "./feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374fe26c",
  null
  
)

export default component.exports